import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  HttpErrorHandlerService,
  HandleError,
} from './http-error-handler.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseSvcService {
  // public activeURL:string = 'http://localhost:58419/';
  // public activeURL:string="https://perfectlearningapp.azurewebsites.net/";
  //  public activeURL:string="http://www.perfectlearningapp.com/";

  // public activeURL: string = 'https://www.perfectlearningapp.com/';

  //  public activeURL:string="http://uat.perfectlearningapp.com/";

  //  public activeURL:string="https://dev.perfectlearningapp.com/";
  public activeURL: string = environment.apiBaseUrl;

  public handleError: HandleError;
  public _httpoption = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',

      //Authorization: 'my-auth-token'
    }),
  };
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService
  ) {
    this.handleError = httpErrorHandler.createHandleError('HeroesService');
  }
}
